import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class AuthorityService {
  private static currentUserAuthorities: string[] = [];
  
  static setAuthorities(authorities: string[]) {
    this.currentUserAuthorities = authorities;
  }
  
  static hasEveryAuthority(authorities: string[]): boolean {
    if (authorities.includes("*"))
      return true;
    return authorities.every(authority => this.currentUserAuthorities.includes(authority));
  }

  static hasSomeAuthority(authorities: string[]): boolean {
    if (authorities.includes("*"))
      return true;
    return authorities.some(authority => this.currentUserAuthorities.includes(authority));
  }
}
